import * as assetConstants from '../constants/assets';
import { BATCH_ACTION_TYPES } from './AssetBatchActionTypes';

export const ASSET_BATCH_ACTIONS = {
    [BATCH_ACTION_TYPES.DUPLICATE]: assetConstants.DUPLICATE_ASSETS_REQUEST,
    [BATCH_ACTION_TYPES.MOVE_TO]: assetConstants.MOVE_ASSETS_REQUEST,
    [BATCH_ACTION_TYPES.COPY_TO]: assetConstants.COPY_ASSETS_REQUEST,
    // [BATCH_ACTION_TYPES.DOWNLOAD]: assetConstants.DOWNLOAD_ASSETS_REQUEST, // disabled for now
    [BATCH_ACTION_TYPES.PUBLISH]: assetConstants.PUBLISH_ASSETS_REQUEST,
    [BATCH_ACTION_TYPES.DELETE]: assetConstants.DELETE_ASSETS_REQUEST,
    [BATCH_ACTION_TYPES.TAG]: assetConstants.TAG_ASSETS_REQUEST,
}; 


// WEBPACK FOOTER //
// ./src/enums/AssetActions.js